<template>
  <section class="status" ref="status">
    <nav class="status-nav">
      <Step
        v-for="(step, i) in steps"
        :index="i"
        :title="step.title"
        :path="step.data.slug"
        :active="i === currentIndex"
        :noanswer="i < currentIndex"
        :answer="answerValue(i)"
        :unit="unitValue(i)"
        :key="step.data.slug"
        ref="steps"
      />
      <Step
        title="Összesítő"
        path="/kerdoiv/osszesito"
        :active="$route.params.step === 'osszesito'"
        answer=""
      />
    </nav>
  </section>
</template>

<script>
import Step from "@/components/Step.vue";

export default {
  name: "Status",
  components: {
    Step
  },
  computed: {
    currentIndex() {
      return this.$store.getters.getStepIndex;
    },
    steps() {
      return this.$store.getters.getSteps;
    },
    answers() {
      return this.$store.getters.getAnswers;
    }
  },
  mounted() {
    this.scrollToIndex(this.currentIndex, true);
  },
  methods: {
    answerValue(i) {
      const a = this.answers[i];
      if (typeof a === "string")
        return this.steps[i].data.items.find(item => item.key === a).label;
      if (a instanceof Array) return "+" + a.length;
      if (a instanceof Object) return a[a.type];
      return a;
    },
    unitValue(i) {
      if (this.steps[i].data.unit !== undefined) {
        return this.steps[i].data.unit;
      }
      const a = this.answers[i];
      if (a instanceof Object) {
        return this.steps[i].data.items[a.type].unit;
      }
      return null;
    },
    scrollToIndex(index, noanim) {
      const el = this.$refs.steps[index].$el;
      const parent = this.$refs.status;
      parent.classList[noanim ? "remove" : "add"]("animscroll");

      setTimeout(() => {
        const elhalfheight = el.offsetHeight / 2;
        const parhalfheight = parent.offsetHeight / 2;
        const elhalfwidth = el.offsetWidth / 2;
        const parhalfwidth = parent.offsetWidth / 2;

        if (parent.offsetHeight < parent.offsetWidth) {
          parent.scrollLeft = el.offsetLeft + elhalfwidth - parhalfwidth;
        } else {
          parent.scrollTop = el.offsetTop + elhalfheight - parhalfheight;
        }
      }, 200);
      /* if (el.scrollIntoView) {
        el.scrollIntoView({
          block: "center",
          behavior: noanim ? "auto" : "smooth",
        });
      } else {
        el.scrollIntoViewIfNeeded(true);
      } */
    }
  },
  watch: {
    currentIndex(index) {
      this.scrollToIndex(index);
    }
  }
};
</script>

<style lang="scss">
.status {
  box-sizing: border-box;
  height: 46px;
  width: 100%;
  height: 63px;
  flex: 0 0 63px;
  // margin-top: 64px;
  overflow-x: scroll;
  overflow-y: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-behavior: auto;
  &::-webkit-scrollbar {
    display: none;
  }

  &.animscroll {
    scroll-behavior: smooth;
  }

  .status-nav {
    width: 100%;
    padding: 0;
    height: 46px;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    white-space: nowrap;
  }

  @media screen and (min-width: $breakpoint) {
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100%;
    min-width: 208px;
    margin-top: 0;
    min-height: 130px;

    .status-nav {
      display: flex;
      width: auto;
      flex-direction: row;
      gap: 10px;
      flex-wrap: nowrap;
      align-items: center;
      height: auto;
      white-space: wrap;
    }
  }
}
</style>
